module.exports = __webpack_public_path__ + "img/plagiarism-bg.13654ac.svg?v=1744194310396";